import { Link } from "react-router-dom";
import React from "react";

export default function Footer() {
  return (
    <div className="footer__area pb-40">
      <div className="container">
        <div className="footer-items-container">
          <div className="footer__area-widget-about-logo">
            <Link to="/">
              <img src="assets/img/logo.png" alt="" />
            </Link>
          </div>
          <div className="footer__area-widget-contact-item">
            <div className="footer__area-widget-contact-item-icon">
              <i className="fal fa-map-marked-alt"></i>
            </div>
            <div className="footer__area-widget-contact-item-content">
              <span>
                <a href="https://maps.app.goo.gl/cVtNPynYM3Cxz5F97">
                  Enjoy Apartments, Prilep 7500
                </a>
              </span>
            </div>
          </div>
          <div className="footer__area-widget-contact-item">
            <div className="footer__area-widget-contact-item-icon">
              <i className="fal fa-envelope-open-text"></i>
            </div>
            <div className="footer__area-widget-contact-item-content">
              <span>
                <a href="mailto:stevanangija@yahoo.com">Email us</a>
              </span>
            </div>
          </div>
          <div className="footer__area-widget-contact-item">
            <div className="footer__area-widget-contact-item-icon">
              <i className="fal fa-phone-alt"></i>
            </div>
            <div className="footer__area-widget-contact-item-content">
              <span>
                <a href="tel:+38971225628">+389 (71) 225 628</a>
              </span>
            </div>
          </div>
          <div className="footer__area-widget-contact-item">
            <div className="footer__area-widget-contact-item-icon">
              <i className="fab fa-facebook-f"></i>
            </div>
            <div className="footer__area-widget-contact-item-content">
              <span>
                <a
                  href="https://www.facebook.com/profile.php?id=61553303026937"
                  target="_blank"
                  rel="noreferrer"
                >
                  Enjoy Apartments
                </a>
              </span>
            </div>
          </div>
          <div className="footer__area-widget-contact-item">
            <div className="footer__area-widget-contact-item-icon"></div>
            <div className="footer__area-widget-contact-item-content"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
